<ng-container *transloco="let t">
  @if (race && isFullScreen) {
  <ng-template [ngTemplateOutlet]="fullScreenHeader"></ng-template>
  @if (fullScreenMode === FullScreenMode.FULL) {
  <ng-template [ngTemplateOutlet]="results"></ng-template>
  }
  @else {
  <ng-template [ngTemplateOutlet]="splitResults"></ng-template>
  }
  <ng-template [ngTemplateOutlet]="splitButtons"></ng-template>
  <ng-template [ngTemplateOutlet]="fullScreenFooter"></ng-template>
  }
  @else {
  <app-page-template [showBreadcrumbs]="false">
    <app-carousel [images]="[image]" [showGradient]="true">
    </app-carousel>
    <ng-template [ngTemplateOutlet]="header"></ng-template>
    <ng-template [ngTemplateOutlet]="results"></ng-template>
    <app-footer/>
  </app-page-template>
  }

  <ng-template #fullScreenHeader>
    <div class="full-screen-header">
      <div class="race-title">
        <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages" [event]="event"
                                  [finished]="liveResult?.finished ?? 0" [type]="LiveResultHeadingType.RACE"
                                  [hideStatusBadge]="true" cssClass="full-screen"/>
      </div>
      <div class="title">
        {{ t("page.header.live.results") }}
      </div>
    </div>
  </ng-template>



  <ng-template #resultsTable>
    <div class="live-results-card">
        <app-live-results-table-body [competitorLiveResults]="competitorLiveResults" [leading]="leading"></app-live-results-table-body>
      <div class="live-results-card__footer">
        <app-three-dots/>
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <div class="container pt-62-32">
      <app-live-results-heading [race]="race" [countries]="countries" [languages]="languages"
                                [finished]="liveResult?.finished ?? 0" [event]="event" [type]="LiveResultHeadingType.RACE"/>
      <div class="live-results-filter">
        <div class="d-flex">
          <div class="live-results-filter__search-wrapper">
            <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                        (searchQuery)="handleInput($event)" [inputValue]="name"/>
          </div>
          <form #f>
            <div class="contestants-filter__grid">
              <div class="contestants-filter__grid-inner">
                <div ngbDropdown class="dropdown-small" container="body">
                  <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                    {{
                    gender
                      ? t("app.common.gender." + gender) : t("competitor.table.gender")
                    }}
                  </div>
                  <div ngbDropdownMenu aria-labelledby="genderDropdown">
                    <button ngbDropdownItem (click)="handleGenderSelection()">
                      {{ t("app.common.all") }}
                      @if ((gender === undefined)) {
                      <i class="bi bi-check"></i>
                      }
                    </button>
                    @for (item of genders;track item.id) {
                    <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                    {{ t("app.common.gender." + item.id) }}
                    @if (item.id === gender) {
                    <i class="bi bi-check"></i>
                    }
                    </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="live-results-filter__button">
          <div class="d-flex align-items-center justify-content-center">
            <div class="text-uppercase text-black cursor-pointer" (click)="exportToPDF()">
              {{ t('app.common.export.to.pdf') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #fullScreenFooter>
    <div class="footer">
      <img src="assets/icons/tracey_logo_small.svg" alt="Tracy logo" class="logo" (click)="logoClicked()">
    </div>
  </ng-template>

  <ng-template #splitButtons>
    @if (competitorLiveResults.length ?? 0 > 0 && race) {
    <div class="full-screen-bottom-buttons">
      <app-rounded-button
        [label]="t(fullScreenMode === FullScreenMode.SPLIT ? 'live.results.see.all.full' : 'live.results.see.split')"
        (onClick)="toggleView()"
        [btnClass]="'rounded-button--solid fixed-height'"
      />
    </div>
    }
  </ng-template>

  <ng-template #splitResults>
    <div class="full-screen-container">
    <div class="row">
      <div class="col-md-6 col-12 p-0 pe-0 pe-md-2">
        <div class="table-header">
          <app-header-alt [title]=" t('app.common.gender.1') | uppercase" [isBold]="true"/>
        </div>
        <div class="live-results-card">
          <app-live-results-table-body [competitorLiveResults]="competitorLiveResults" [leading]="leading" [filterGender]="Gender.MALE"></app-live-results-table-body>
          <div class="live-results-card__footer">
            <app-three-dots/>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 p-0 ps-0 ps-md-2 pt-2 pt-md-0">
        <div class="table-header">
          <app-header-alt [title]=" t('app.common.gender.2') | uppercase" [isBold]="true"/>
        </div>
        <div class="live-results-card">
          <app-live-results-table-body [competitorLiveResults]="competitorLiveResults" [leading]="leading" [filterGender]="Gender.FEMALE"></app-live-results-table-body>
          <div class="live-results-card__footer">
            <app-three-dots/>
          </div>
        </div>      </div>
    </div>
    </div>
  </ng-template>


  <ng-template #results>
      <div [class.padding-bottom-92]="!isFullScreen"
           [class.container]="!isFullScreen"
           [class.full-screen-container]="isFullScreen"
           [class.pb-300-228]="!isFullScreen"
           [class.mt-21]="!isFullScreen">
            @if (((leading?.length ?? 0 > 0) || (competitorLiveResults.length ?? 0) > 0) && race) {
             <ng-template [ngTemplateOutlet]="resultsTable"></ng-template>
            } @else {
            <div class="pt-4">
              <app-empty-state [addPaddingBottom]="isFullScreen"/>
            </div>
            }
      </div>
  </ng-template>
</ng-container>
